export const keywords = [
  '경제',
  '생산력',
  '국가경쟁력',
  '이민정책',
  '지방소멸',
  '저출산',
  '고령화',
  '다문화가정',
];
